import { FETCH_DATA } from "./types";

export const fetchData = (payload) => ({
  type: FETCH_DATA,
  payload
})